import styled from '@emotion/styled'
import { ITheme } from 'utils/type'

interface IProposalElementProps {
  theme: ITheme
}

export const BannerHeader = styled.h1`
  label: BannerHeader;
  margin-bottom: 20px !important;
  text-align: left;
  color: #000 !important;
  @media (max-width: 719px) {
    line-height: 32px;
  }
`

export const CarName = styled('div')`
  label: CarName;
  font-weight: 900;
  font-size: 34px;
  text-align: center;
  color: #000;
  text-align: center;
`

export const CarBodySection = styled('div')`
  label: CarBodySection;
  display: flex;
  > div:first-of-type {
    padding-right: 2px;
  }
`

export const CarImageSection = styled('div')`
  label: CarImageSection;
  width: 50%;
  img {
    height: auto;
    width: auto;
    max-height: 170px;
  }
`
export const NovatedLeaseSection = styled('div')`
  label: NovatedLeaseSection;
  display: flex;
  svg {
    margin-right: 24px;
    margin-top:12px;
  }
  div {
    width: 100%;
    div {
      width: 102%;

      div {
        padding-right: 0;
      }
    }
  }
`
export const DeductionTotalContainer = styled('div')`
  label: DeductionTotalContainer;
  display: flex;
  margin: 0 21px 21px 21px;
  border-radius: 4px;
  font-size: 14px;
  background: ${(props)=> props.theme.backgrounds.backGround1};
  justify-content: space-between;
  & > div:first-of-type {
    padding: 10px 24px;
    flex-grow: 1;
  }
  div:nth-of-type(2) {
    margin: 0;
    h2 {
      font-size: 14px;
    }
    b {
      font-size: 24px;
      font-weight: 900;
    }
  }
`
export const DeductionTotalBlock = styled('div')<IProposalElementProps>`
  label: DeductionTotalBlock;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 15px;
  font-size:${(props)=>props.theme.font.size.small};
  color: ${(props) => props.theme.colors.secondary};
  & > b {
    font-weight: 900;
  }
`
export const ProposalReviewPage = styled('div')`
  label: ProposalReviewPage;
  div:first-child {
    min-height: auto;
  }
  .box {
    display: flex;
    overflow: hidden;
    .left {
      flex-grow: 1;
    }
  }

  .value-container {
    display: flex;
    justify-content: space-between;
    width: 36%;
    padding: 3px 1em;
  }

  .left {
    padding: 3px 1em;
    flex: 0 0 150px;
    font-weight: 900 !important;
  }

  .right {
    text-align: right;
    width: 50%;
  }

  .link-text {
    text-decoration: underline;
    color: $primary-color;
    cursor: pointer;
  }
  .card-header {
    background-color: $primary-color;
    color: $light;
  }

  .proposal-summary-section {
    .subtitle {
      font-weight: normal;
      font-size: 75%;
    }
  }
`

export const PDSLink = styled.a`
  label: PDSLink;
  font-weight: normal !important;
  text-decoration: underline;
  color: ${(props)=> props.theme.colors.secondary};
  &:hover {
    text-decoration: none;
    cursor: pointer;
    color: ${(props) => props.theme.colors.navColor};
  }
`

export const BannerContent = styled('div')<IProposalElementProps>`
  label: BannerContent;
  text-align: left;
  color: ${(props) => props.theme.colors.textDarkblack};
  max-width: 1140px;
  margin: 0 auto;
`
export const BannerInfoTitle = styled('h1')`
  label: BannerInfoTitle;
  margin-bottom: 0.5rem;
`

export const BannerInfoContent = styled('div')`
  label: BannerInfoContent;
  margin-bottom: 0.5rem;
  font-size: 20px;
  line-height: 36px;
  color: #000;
  @media (max-width: 719px) {
    line-height: 32px;
  }
  > span> a { 
    color: #000;
    font-weight: bold;
    &:hover {
      color: ${(props) => props.theme.colors.grey2};
    }
  }
`
export const AuthorizationText = styled.div<IProposalElementProps>`
  label: AuthorizationText;
  background-color: ${(props) => props.theme.backgrounds.backGround1};
  padding: 15px;
  font-weight: ${(props) => props.theme.font.weight.semiBold} !important;
  border-radius: 8px;
  display: flex;
  align-items: center;
  input[type='checkbox'] {
    position: relative;
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
  
  input[type='checkbox']:checked {
    filter: invert(100%) hue-rotate(211deg) brightness(2);

    }
`
export const EmissionContainer = styled('div')`
  label: emissionContainer;
  padding-bottom: 30px;
`

export const EmissionContainerPdf = styled(EmissionContainer)`
  label: emissionContainer;
  padding: 0px 10px 40px;
`

export const ViewPDFDiv = styled.div`
  label: ViewPDFDiv;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: flex-end;
  @media (max-width: 719px) {
    display: inline;
    justify-content: inherit;
  }
`
export const DeductionTotalContainerMobile = styled.div<IProposalElementProps>`
  label: DeductionTotalContainerMobile;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.backgrounds.backGround3};
  margin: 12px;
`

export const DeductionColorBlockMobile = styled.div<IProposalElementProps>`
  label: DeductionColorBlockMobile;
  text-align: center;
  width: 100%;
  background-color: ${(props) => props.theme.colors.alertGreen};
  color: ${(props) => props.theme.colors.white};
  box-sizing: border-box;
  padding: 10px;
`

export const CentredImageDiv = styled.div`
  label: CentredImageDiv;
  display: flex;
  justify-content: center;
`
export const SubMenuContainer = styled('div')`
  label: SubMenuContainer;
  position: sticky;
  top: 0;
  z-index: 10;
`
